import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

const S = ({ title, children }) => (
  <div className="mt-7">
    <h2 className="font-head text-lg font-bold">{title}</h2>
    <p className="mt-2 text-zinc-600 leading-relaxed">{children}</p>
  </div>
);

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl mx-auto px-5 py-10" data-testid="privacy-page">
      <button data-testid="privacy-back" onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-zinc-500 hover:text-[#0A0A0A] mb-4"><ArrowLeft size={16} /> Terug</button>
      <h1 className="font-head text-3xl font-black tracking-tight">Privacybeleid</h1>

      <S title="1. Wie zijn wij">GuardLink (KvK-nummer 42112367) is een platform dat zzp-beveiligers en opdrachtgevers met elkaar verbindt. GuardLink is verantwoordelijk voor de verwerking van jouw persoonsgegevens in de app.</S>
      <S title="2. Welke gegevens verzamelen wij">Accountgegevens (naam, e-mailadres, wachtwoord), bedrijfs-/KvK-gegevens, jouw beveiligingspas of legitimatie die je uploadt voor verificatie, klus- en locatiegegevens, chatberichten en betaalstatus via onze betaalprovider Stripe.</S>
      <S title="3. Waarvoor gebruiken wij je gegevens">Om je account te beheren, klussen te tonen en te matchen, betalingen te verwerken, chats mogelijk te maken, beveiligers te verifiëren en de app veilig te houden.</S>
      <S title="4. Delen met derden">Wij delen gegevens alleen wanneer nodig: met Stripe voor betalingen en met opdrachtgevers/zzp'ers zodra een klus is ontgrendeld. Wij verkopen jouw gegevens nooit.</S>
      <S title="5. Bewaartermijn">Wij bewaren je gegevens zolang je account actief is. Bij verwijdering van je account worden je persoonsgegevens en uploads uit de app verwijderd.</S>
      <S title="6. Jouw rechten">Je kunt je gegevens inzien, corrigeren en je account op elk moment in de app verwijderen via Profiel → Account verwijderen. Dit verwijdert je persoonsgegevens.</S>
      <S title="7. Contact">Vragen over privacy? Neem contact met ons op via de supportknop op het welkomstscherm of per e-mail via guardlink12@gmail.com.</S>

      <p className="mt-10 text-xs text-zinc-400">Laatst bijgewerkt: juni 2026</p>
    </div>
  );
}
